import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useStagesApi Hook
 *
 * Pure API hook for stage operations.
 *
 * @returns {Object} - { getStageChildren, getSubmissionStages }
 */
const useStagesApi = () => {
  const getStageChildren = useCallback(async (stageId) => {
    const response = await axiosInstance.get(`/api/stages/children/${stageId}`);
    return response.data;
  }, []);

  /**
   * Get all submission stages for a workflow version in order
   * @param {number} workflowVersionId - Workflow version ID
   * @returns {Promise<Array>} - Ordered array of submission stages with their forms
   */
  const getSubmissionStages = useCallback(async (workflowVersionId) => {
    const response = await axiosInstance.get(
      `/api/workflows/version/${workflowVersionId}/submission-stages`
    );
    return response.data;
  }, []);

  /**
   * Get submission stages for a request (includes filled form data for send-back)
   * @param {number} requestId - Request ID
   * @returns {Promise<Array>} - Submission stages with forms and any filled data
   */
  const getRequestSubmissionStages = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/requests/${requestId}/submission-stages`
    );
    return response.data;
  }, []);

  return {
    getStageChildren,
    getSubmissionStages,
    getRequestSubmissionStages,
  };
};

export default useStagesApi;
